import { Injectable, Injector } from '@angular/core';
import { IGetInstanceService } from '@fi-app/utilities/fi-model/get-instance-service';
import { FiFranchiseIntranetUpgradeListDataModel } from './franchise-intranet-upgrade-list-data.model';

@Injectable()
export class FiFranchiseIntranetUpgradeListDataService implements IGetInstanceService {
    constructor(private injector: Injector) {}

    getInstance(isLocalSort?: boolean) {
        return new FiFranchiseIntranetUpgradeListDataModel(this.injector, isLocalSort);
    }
}
